import removeMarks from "./removeMarks";
import addMark from "./addMark";

export {
	addMark,
	removeMarks,
};
